export default __webpack_public_path__ + "static/media/Lupine_Curved_Grayscale_2.02299758.png";